import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import Cart from './Pages/Cart/Cart'
import Contact from './Pages/Contact/Contact';
import Sofacleaning from './Pages/SofaCleaning/Sofacleaning';
import Bathroom from './Pages/Bathroom/Bathroom';
import Kitchen from './Pages/Kitchen/Kitchen';
import HomeCleaning from './Pages/HomeCleaning/HomeCleaning';
import Profile from "./Pages/UserProfile/Profile";
import { AuthProvider, AuthContext } from "./AuthContext";
import { useContext, useState } from "react";
import TermConditions from './Pages/Term&Conditions/Termcondition';
import Privacy from './Pages/PrivacyPolicy/Privacypolicy';
import Checkout from './Pages/Checkout/Checkout1';
import MainHome from './Pages/Home/MainHome';
import Whatsuplogo from './Images/HomeImages/Whatsupimg.png'
import RefundPolicy from './Pages/Refund Policy/RefundPolicy'
import HelpSupport from './Pages/HelpSupport/HelpSupport'
import SafetyCenter from './Pages/SafetyCenter/SafetyCenter'
import CommunityGuidelines from './Pages/CommunityGuidelines/CommunityGuidelines'
import Reviews from './Pages/Reviews/Reviews'
import WhatsAppModal from './Components/WhatsAppModal/WhatsAppModal'
// import Login from './Components/Login/Login';

function PrivateRoute({ children }) {
  const { user } = useContext(AuthContext);
  return user ? children : <Navigate to="/" />;
}
function Success() {
  return (
    <div className="flex items-center justify-center h-screen">
      <h1 className="text-2xl font-bold text-green-500">Payment Successful!</h1>
    </div>
  );
}

function Failure() {
  return (
    <div className="flex items-center justify-center h-screen">
      <h1 className="text-2xl font-bold text-red-500">Payment Failed!</h1>
    </div>
  );
}
function App() {
  const [whatsappModalOpen, setWhatsappModalOpen] = useState(false);

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    setWhatsappModalOpen(true);
  };

  const closeWhatsAppModal = () => {
    setWhatsappModalOpen(false);
  };

  return (
    <>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path='/' element={<MainHome />}></Route>
            <Route path='/about' element={< About />}></Route>
            <Route path='/cart' element={<Cart />}></Route>
            <Route path='/contact' element={< Contact />}></Route>
            <Route path='/sofa-cleaning' element={< Sofacleaning />}></Route>
            <Route path='/bathroom-cleaning' element={< Bathroom />}></Route>
            <Route path='/checkout' element={< Checkout />}></Route>
            <Route path='/Kitchen-cleaning' element={< Kitchen />}></Route>
            <Route path='/term&condition' element={<TermConditions />}></Route>
            <Route path='/refundPolicy' element={<RefundPolicy />}></Route>
            <Route path='/home-cleaning' element={< HomeCleaning />}></Route>
            <Route path='/privacypolicy' element={<Privacy />}></Route>
            <Route path='/services' element={<Privacy />}></Route>
            <Route path='/help-support' element={<HelpSupport />}></Route>
            <Route path='/safety-center' element={<SafetyCenter />}></Route>
            <Route path='/community-guidelines' element={<CommunityGuidelines />}></Route>
            <Route path='/reviews' element={<Reviews />}></Route>
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/payment-success" element={<Success />} />
            <Route path="/payment-failure" element={<Failure />} />
            {/* <Route path="/login" element={<Login/>} /> */}
          </Routes>
        </Router>
        <div className='fixed-bottom right-100 p-3 whatsuplogo' style={{ zIndex: '9999', left: 'initial', position: 'fixed' }}>
          <a href="#" onClick={handleWhatsAppClick} style={{ cursor: 'pointer' }}>
            <img src={Whatsuplogo} alt="WhatsApp" />
          </a>
        </div>
        {whatsappModalOpen && <WhatsAppModal onClose={closeWhatsAppModal} />}
      </AuthProvider>
    </>
  );
}

export default App;